import { lazy } from "react"
import { FunctionComponent } from "react"
import {
  Monitor,   // tog'a #3460: «Табло склада»
  BarChart2,
  Book,
  Bookmark,
  CornerUpLeft,
  DollarSign,
  FileText,
  Repeat,
  // Gift,
  Globe,
  Grid,
  Home as HomeIcon,
  Icon,
  Layers,
  MessageCircle,
  Pocket,
  Percent,
  ShoppingBag,
  Tool,
  ShoppingCart,
  Shuffle,
  Trash2,
  UserCheck,
  Users,
  Shield,
  Database,
  Activity,
  HardDrive,
  Briefcase,
  Award,
  Truck,
  Clipboard,
  FileText as FileContract,
  Gift,
  CreditCard,
  UserPlus,
  Send,
  Clock,
  Inbox,   // tog'a #3563 2-qism: «Заявки партнёров»
} from "react-feather"
import { GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE } from "./../pages/returnSales/queries"
import Transfers from "../pages/transfers"

const Roles = lazy(() => import("../pages/roles/index"))
const Backups = lazy(() => import("../pages/backups"))

const Home = lazy(() => import("../pages/home"))
const Money = lazy(() => import("../pages/money"))
const Purchase = lazy(() => import("../pages/purchases"))
const FactoryPurchase = lazy(() => import("../pages/factoryPurchases"))
// Vendor Portal TZ (155-xabar): zavod kabineti qayta so'raldi — marshrut tiklandi
const FactoryShipments = lazy(() => import("../pages/factoryShipments"))
const ShopCabinet = lazy(() => import("../pages/shopCabinet"))
const Pos = lazy(() => import("../pages/pos"))   // Boshliq (2026-09-05): «Касса (POS)» — magazin kassasi
const Reports = lazy(() => import("../pages/reports"))
const BankReport = lazy(() => import("../pages/bankReport"))   // tog'a 1151 (2026-09-04): «Банк» alohida bo'lim
const WarehouseDesk = lazy(() => import("../pages/warehouseDesk"))
const InventoryCounts = lazy(() => import("../pages/inventoryCounts"))   // tog'a #4743: «Инвентаризация»
const WarehouseBoard = lazy(() => import("../pages/warehouseBoard"))   // tog'a #3457/#3460: «Табло склада»   // tog'a #3445/#3450 (2026-10-04): «Окно склада»
const Wallet = lazy(() => import("../pages/wallet"))   // Boshliq (2026-09-22): «Кошелёк» — kirim/chiqim yig'ma hisoboti
const Sale = lazy(() => import("../pages/sale"))
const Counterparties = lazy(() => import("../pages/counterparties"))
const Products = lazy(() => import("../pages/products"))
const Residues = lazy(() => import("../pages/residues"))
const Warehouses = lazy(() => import("../pages/warehouses"))
const Factories = lazy(() => import("../pages/factories"))
const Showcases = lazy(() => import("../pages/showcases"))
const Managers = lazy(() => import("../pages/managers"))
// S5: yagona foydalanuvchilar bo'limi (menejer/kontragent/... bitta joyda)
const UsersDirectory = lazy(() => import("../pages/usersDirectory"))
// S16: kontragent/magazin tizimidan yetkazuvchiga buyurtma
const OrderToMain = lazy(() => import("../pages/orderToMain"))
// S18: glavniy admin uchun tizimlar (kontragent/magazin) boshqaruv paneli
const TenantsPanel = lazy(() => import("../pages/tenants"))
const Trash = lazy(() => import("../pages/trash"))
const Orders = lazy(() => import("../pages/orders"))
const ReturnSales = lazy(() => import("../pages/returnSales"))
const ReturnPurchases = lazy(() => import("../pages/returnPurchases"))
// Yagona chat (egasi 2026-09-02): Деньги chat + Заказ chat o'rniga bitta sahifa; eski marshrutlar redirect
const Chat = lazy(() => import("../pages/chat"))
const ChatRedirect = lazy(() => import("../pages/chat/redirect"))
// Egasi (2026-09-01): zakaz chat endi pul chat kabi mustaqil sahifa —
// kontragent «Заказы» huquqisiz ham o'z zakaz suhbatiga kira oladi.
const Expenses = lazy(() => import("../pages/expenses"))
const Control = lazy(() => import("../pages/control/control"))
const DiscountedProducts = lazy(() => import("../pages/discountedProducts"))
const DataAdmin = lazy(() => import("../pages/dataAdmin/index"))
// Do'konga chiqarish (2026-09-30): maxfiylik/yordam sahifalari rekvizitlari — faqat glavniy admin
const LegalPages = lazy(() => import("../pages/legalPages"))
const AuditLogs = lazy(() => import("../pages/auditLogs"))
// 6-7 bosqich modullari (HR, logistika, do'kon, mijozlar)
const Employees = lazy(() => import("../pages/employees"))
const Salaries = lazy(() => import("../pages/salaries"))
const KPI = lazy(() => import("../pages/kpi"))
// tog'a #2894 (2026-09-26): davomat — Face ID terminal, telefon (GPS), tabel
const Attendance = lazy(() => import("../pages/attendance"))
const Declarations = lazy(() => import("../pages/declarations"))
const Contracts = lazy(() => import("../pages/contracts"))
const Declarant = lazy(() => import("../pages/declarant"))
const Deliveries = lazy(() => import("../pages/deliveries"))
const Shops = lazy(() => import("../pages/shops"))
const Customers = lazy(() => import("../pages/customers"))
// tog'a #2849/#2874 (2026-09-26): «Рассылка» — hamkorlarga ommaviy xabar
const Broadcasts = lazy(() => import("../pages/broadcasts"))
// tog'a #3563 2-qism (2026-10-07): «Заявки партнёров» — /apply ochiq sahifasidan kelgan hamkor arizalari
const PartnerApplications = lazy(() => import("../pages/partnerApplications"))
const AbonentPage = lazy(() => import("../pages/abonent"))   // tog'a #3975/#3984: abonent to'lovi

export function ReturnSalesIsDefective() {
  return (
    <ReturnSales
      isDefective
      hasPhoto
      pageName="returnSalesIsDefective"
      exportQuery={GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE}
    />
  )
}

export interface MenuItem {
  icon: Icon
  component?: FunctionComponent<any> //TODO add components
  title: string
  seoTitle: string
  route: string
  link?: string | ""
}
const GlobalPanel = lazy(() => import("../pages/globalPanel"))

const menuItems: MenuItem[] = [
  {
    icon: HomeIcon,
    component: Home,
    title: "home",
    seoTitle: "home",
    route: "/",
  },
  // S22: yangi global panel — Home'dan keyin, barcha tenant turlari ko'radi
  {
    icon: BarChart2,
    component: GlobalPanel,
    title: "globalPanel",
    seoTitle: "globalPanel",
    route: "/globalPanel",
  },
  {
    icon: Pocket,
    component: Sale,
    title: "sale",
    seoTitle: "sale",
    route: "/sales",
  },
  {
    icon: ShoppingBag,
    component: Purchase,
    title: "purchase",
    seoTitle: "purchase",
    route: "/purchases",
  },
  {
    icon: ShoppingBag,
    component: FactoryPurchase,
    title: "factoryPurchases",
    seoTitle: "factoryPurchases",
    route: "/factoryPurchases",
  },
  {
    icon: Globe,
    component: FactoryShipments,
    title: "factoryShipments",
    seoTitle: "factoryShipments",
    route: "/factoryShipments",
  },
  {
    icon: ShoppingBag,
    component: ShopCabinet,
    title: "shopCabinet",
    seoTitle: "shopCabinet",
    route: "/shopCabinet",
  },
  {
    // Boshliq (2026-09-05): «Касса (POS)» — magazin kassiri ekrani (sotuv + skladga tezkor zakaz), modul: pos
    icon: ShoppingCart,
    component: Pos,
    title: "pos",
    seoTitle: "pos",
    route: "/pos",
  },
  {
    icon: DollarSign,
    component: Expenses,
    title: "expenses",
    seoTitle: "expenses",
    route: "/expenses",
  },
  {
    icon: CornerUpLeft,
    title: "returnSale",
    seoTitle: "returnSale",
    route: "/returnSales",
    component: ReturnSales,
  },
  {
    icon: CornerUpLeft,
    title: "returnPurchase",
    seoTitle: "returnPurchase",
    route: "/returnPurchases",
    component: ReturnPurchases,
  },
  {
    icon: Shuffle,
    title: "defects",
    seoTitle: "defects",
    route: "/defects",
    component: ReturnSalesIsDefective,
  },
  {
    icon: Repeat,
    title: "transfers",
    seoTitle: "transfers",
    component: Transfers,
    route: "/transfers",
  },
  {
    icon: Grid,
    title: "goods",
    seoTitle: "goods",
    component: Products,
    route: "/products",
  },
  {
    icon: Percent,
    title: "discounts",
    seoTitle: "discounts",
    component: DiscountedProducts,
    route: "/discountedProducts",
  },
  {
    icon: ShoppingCart,
    title: "residues",
    seoTitle: "residues",
    route: "/residues",
    component: Residues,
  },
  {
    // tog'a #4743 (2026-10-18): «Инвентаризация» — skladda real sanash; modul (huquq) kodi = marshrut «inventoryCounts»
    icon: Clipboard,
    component: InventoryCounts,
    title: "inventoryCounts",
    seoTitle: "inventoryCounts",
    route: "/inventoryCounts",
  },
  {
    icon: DollarSign,
    component: Money,
    title: "money",
    seoTitle: "money",
    route: "/moneys",
  },
  {
    // tog'a 1145/1151 (2026-09-04): «Банк» — alohida bo'lim (bank hisob raqami kirim/chiqim, faqat ko'rish); modul: bankReport
    icon: DollarSign,
    component: BankReport,
    title: "bankReport",
    seoTitle: "bankReport",
    route: "/bankReport",
  },
  {
    // Boshliq (2026-09-22): «Кошелёк» — tizimga qayerdan pul kirdi va qayerga chiqdi (yig'ma hisobot).
    // Huquq «Деньги» (moneys) bo'yicha — pul bo'limi ochiq bo'lganlarga ko'rinadi.
    icon: DollarSign,
    component: Wallet,
    title: "wallet",
    seoTitle: "wallet",
    route: "/wallet",
  },
  {
    // tog'a #3445/#3450 (2026-10-04): «Окно склада» — skladchiga yo'naltirilgan zakaz qatorlari (taymer bilan)
    icon: Clipboard,
    component: WarehouseDesk,
    title: "warehouseDesk",
    seoTitle: "warehouseDesk",
    route: "/warehouseDesk",
  },
  {
    // tog'a #3457/#3460 (2026-10-04): katta monitor uchun tablo (+ login'siz monitor havolasi)
    icon: Monitor,
    component: WarehouseBoard,
    title: "warehouseBoard",
    seoTitle: "warehouseBoard",
    route: "/warehouseBoard",
  },
  {
    icon: Users,
    title: "counterparties",
    seoTitle: "counterparties",
    route: "/counterparties",
    component: Counterparties,
  },
  {
    icon: Layers,
    component: Warehouses,
    title: "warehouses",
    seoTitle: "warehouses",
    route: "/warehouses",
  },
  {
    icon: Book,
    title: "showcases",
    seoTitle: "showcases",
    route: "/showcases",
    component: Showcases,
  },
  {
    icon: BarChart2,
    title: "factories",
    seoTitle: "factories",
    route: "/factories",
    component: Factories,
  },
  {
    icon: Bookmark,
    title: "orders",
    seoTitle: "orders",
    route: "/orders",
    component: Orders,
  },
  {
    icon: Truck,
    title: "deliveries",
    seoTitle: "deliveries",
    route: "/deliveries",
    component: Deliveries,
  },
  {
    icon: HomeIcon,
    title: "shops",
    seoTitle: "shops",
    route: "/shops",
    component: Shops,
  },
  {
    icon: UserPlus,
    title: "customers",
    seoTitle: "customers",
    route: "/customers",
    component: Customers,
  },
  {
    icon: Send,
    title: "broadcasts",
    seoTitle: "broadcasts",
    route: "/broadcasts",
    component: Broadcasts,
  },

  {
    // Yagona chat (egasi 2026-09-02): menyuda emas — sarlavhadagi tugma (ChatBell); Sidebar yashiradi
    icon: MessageCircle,
    title: "chat",
    seoTitle: "chat",
    route: "/chat/:id?",
    component: Chat,
    link: "/chat",
  },
  {
    icon: MessageCircle,
    title: "moneyComments",
    seoTitle: "moneyComments",
    route: "/moneyComments/:id?",
    component: ChatRedirect,
    link: "/moneyComments",
  },
  {
    // Egasi (2026-09-01): zakaz chat — pul chat bilan bir xil, o'z sahifasi.
    // Huquq nomi «orderComments» (Заказ чат) — «Заказы» dan MUSTAQIL, shuning
    // uchun kontragent zakazlar ro'yxatini ko'rmasdan ham chatga kira oladi.
    icon: MessageCircle,
    title: "orderComments",
    seoTitle: "orderComments",
    route: "/orderComments/:id?",
    component: ChatRedirect,
    link: "/orderComments",
  },
  {
    // S18: faqat glavniy adminda ko'rinadi (Sidebar filtri)
    icon: Shield,
    title: "tenantsPanel",
    seoTitle: "tenantsPanel",
    route: "/tenants",
    component: TenantsPanel,
  },
  {
    // tog'a #3563 2-qism: marshrut nomi = huquq nomi «partnerApplications»; faqat glavniy tizim (Sidebar/hasPermission filtri)
    icon: Inbox,
    title: "partnerApplications",
    seoTitle: "partnerApplications",
    route: "/partnerApplications",
    component: PartnerApplications,
  },
  {
    // tog'a #3975/#3984: marshrut nomi = huquq nomi «abonent»; faqat glavniy tizim (MainOnlyModules); bosh admin rol orqali menejerga beradi
    icon: CreditCard,
    title: "abonent",
    seoTitle: "abonent",
    route: "/abonent",
    component: AbonentPage,
  },
  {
    // S16: faqat kontragent/magazin tizimlarida ko'rinadi (Sidebar filtri)
    icon: ShoppingCart,
    title: "orderToMain",
    seoTitle: "orderToMain",
    route: "/orderToMain",
    component: OrderToMain,
  },
  {
    icon: Users,
    title: "usersDirectory",
    seoTitle: "usersDirectory",
    route: "/usersDirectory",
    component: UsersDirectory,
  },
  {
    icon: UserCheck,
    title: "managers",
    seoTitle: "managers",
    route: "/managers",
    component: Managers,
  },
  {
    icon: Briefcase,
    title: "employees",
    seoTitle: "employees",
    route: "/employees",
    component: Employees,
  },
  {
    icon: CreditCard,
    title: "salaries",
    seoTitle: "salaries",
    route: "/salaries",
    component: Salaries,
  },
  {
    icon: Award,
    title: "kpi",
    seoTitle: "kpi",
    route: "/kpi",
    component: KPI,
  },
  {
    icon: Clock,
    title: "attendance",
    seoTitle: "attendance",
    route: "/attendance",
    component: Attendance,
  },
  {
    // Msg 239: Декларации + Контракты bitta bo'limda
    icon: Clipboard,
    title: "declarant",
    seoTitle: "declarant",
    route: "/declarant",
    component: Declarant,
  },
  {
    icon: Clipboard,
    title: "declarations",
    seoTitle: "declarations",
    route: "/declarations",
    component: Declarations,
  },
  {
    icon: FileContract,
    title: "contracts",
    seoTitle: "contracts",
    route: "/contracts",
    component: Contracts,
  },
  {
    icon: Shield,
    title: "roles",
    seoTitle: "roles",
    route: "/roles",
    component: Roles,
  },
  {
    icon: Tool,
    title: "control",
    seoTitle: "control",
    component: Control,
    route: "/control",
  },
  {
    icon: FileText,
    component: Reports,
    title: "reports",
    seoTitle: "reports",
    route: "/reports/:name?",
    link: "/reports",
  },
  {
    icon: Trash2,
    title: "trash",
    seoTitle: "trash",
    route: "/trash",
    component: Trash,
  },
  {
    icon: Database,
    title: "DataAdmin",
    seoTitle: "DataAdmin",
    route: "/dataAdmin",
    component: DataAdmin,
  },
  {
    icon: Activity,
    title: "auditLogs",
    seoTitle: "auditLogs",
    route: "/auditLogs",
    component: AuditLogs,
  },
  {
    icon: HardDrive,
    title: "backups",
    seoTitle: "backups",
    route: "/backups",
    component: Backups,
  },
  {
    icon: FileText,
    title: "legalPages",
    seoTitle: "legalPages",
    route: "/legalPages",
    component: LegalPages,
  },
]

export default menuItems
